module.exports = __webpack_public_path__ + "media/images/logos/logo-met-0bf3c51251a7cd8b3767ca72849dd8b4.svg";